module.exports = __webpack_public_path__ + "img/cc-mastercard.cee4c299.png";